package one.healthium.domain.common

import kotlinx.serialization.Serializable

@Serializable
data class Color(
    val light: Long?,
    val dark: Long?,
)
